import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SafeImage from "@/components/SafeImage";

function AboutPageSection({ sectionSpace }) {
  return (
    <div
      className={`ltn__about-us-area ${sectionSpace}`}
style={{ paddingTop: "20px", paddingBottom: "80px" }}
    >
      <Container>
        <Row className="align-items-stretch">
<Col xs={12} lg={6} className="align-self-stretch">
  <div
    className="about-us-img-wrap about-img-left"
    style={{ height: "100%", position: "relative", minHeight: 360 }}
  >
    <SafeImage
      src="/img/imgs home/Hilltop Heights 14.webp"
      alt="Siddhivinayak Infra - Our Story"
      fill
      sizes="(max-width: 991px) 100vw, 50vw"
      style={{
        objectFit: "cover",
        borderRadius: "8px",
      }}
    />
  </div>
</Col>
          <Col xs={12} lg={6} className="align-self-center">
            <div className="about-us-info-wrap">
              <div className="section-title-area about-page-intro-title mb-20">
                <span className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  Who We Are
                </span>
                <h1 className="section-title">
                  Siddhivinayak Group – Trusted Real Estate Developers in Nagpur
                </h1>
                <p>
                  Siddhivinayak Group, a distinguished venture of the Kunal Padole Group, is a trusted and reputed name in Nagpur real estate, committed to enduring trust,
                  complete transparency, and customer satisfaction. Every residential and commercial project is thoughtfully planned with meticulous attention to detail,
                  refined design, and a strong focus on delivering long-term value to customers and investors.
                </p>
                <p>
                  With a focus on contemporary architecture, superior construction quality, innovation, and disciplined execution, we continue to build a strong reputation
                  among homebuyers and property investors in Nagpur.
                </p>
                <p>
                  As Nagpur grows into a leading Smart City in India, our strategically located properties provide excellent connectivity to key infrastructure,
                  business hubs, schools, hospitals, shopping destinations, and everyday conveniences.
                </p>
              </div>
              <Row className="ltn__list-item-half-check">
                {[
                  "Enduring Trust & Transparency",
                  "Contemporary Architecture",
                  "Superior Construction Quality",
                  "Smart City Location",
                ].map((item, i) => (
                  <Col xs={12} sm={6} key={i} className="d-flex align-items-center mb-3">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      style={{ marginRight: "10px", flexShrink: 0 }}
                    >
                      <circle cx="12" cy="12" r="10" stroke="#f0803c" strokeWidth="2" />
                      <path
                        d="M8 12.5l2.5 2.5L16 9.5"
                        stroke="#f0803c"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>{item}</span>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
      <style jsx>{`
        .about-page-intro-title .section-subtitle {
          display: inline-block;
          margin-bottom: 8px;
        }

        @media (max-width: 767px) {
          .about-page-intro-title {
            margin-top: 24px;
          }
        }
      `}</style>
    </div>
  );
}

export default AboutPageSection;